import React from 'react';
import { useFlow } from '../utilities/useFlow';

export default function Footer(): JSX.Element | null {
  const flow = useFlow();

  if (flow === 'Keepr') {
    return (
      <footer className="App-footer">
        <div className="footer-content">
          <div className="van-container">
            <img
              alt="Delivery van"
              loading="lazy"
              width="192"
              height="100"
              className="van-image"
              src="/img/van.png"
            />
          </div>
        </div>
      </footer>
    );
  }

  if (flow === 'St Annes') {
    return (
      <footer className="App-footer stannes-footer">
        <div className="footer-content stannes-footer-content">
          <div className="stannes-footer-logo">
            <img
              src="/img/svg/st-annes-fullcolour-WHITE-RGB.svg"
              alt="St Anne's College, Oxford"
              className="stannes-footer-svg"
            />
          </div>
          <div className="stannes-footer-info">
            <p>St Anne's College, Woodstock Road, Oxford, OX2 6HS</p>
            <p>Tel: +44 (0)1865 274800</p>
            <a
              href="https://www.st-annes.ox.ac.uk"
              target="_blank"
              rel="noreferrer"
            >
              www.st-annes.ox.ac.uk
            </a>
          </div>
        </div>
      </footer>
    );
  }

  return null;
}
